import { Box, Input, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(9, 8),
  backgroundColor: theme.palette.primary[100],
  borderRadius: theme.spacing(6),
  border: `1px solid ${theme.palette.grey[500]}`,
  width: '100%',
}));

export const StyledInput = styled(Input)(({ theme, error }) => ({
  color: theme.palette.black.A100,
  maxWidth: '50%',
  fontSize: 16,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  padding: theme.spacing(0, 4),
  backgroundColor: theme.palette.common.white,
  border: `1px solid`,
  borderColor: error ? theme.palette.error.main : theme.palette.grey[500],
  borderRadius: 5,
}));
